import type { ReactNode } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollTopButton from '@/components/feature/ScrollTopButton';

interface SiteLayoutProps {
  children: ReactNode;
  overlayHeader?: boolean;
}

export default function SiteLayout({ children, overlayHeader = false }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className={`flex-1 w-full ${overlayHeader ? '' : 'pt-16 md:pt-20'}`}>{children}</main>
      <SiteFooter />
      <ScrollTopButton />
    </div>
  );
}